"use strict";

exports.__esModule = true;
exports.default = void 0;
var _default = exports.default = {
  disabled: false
};